import React,{ useState } from 'react';
import styled from 'styled-components';
import {NavLink} from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';
import {  useHistory } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';


// Components
import StyledPageContent from '../components/StyledPage';
import AuthLayoutWrapper from '../components/AuthLayoutWrapper';
import Button from '../components/Button';
import FormErrors, { trowError } from '../components/FormErrors';
import AcreditacionProfile, { LOGIN_IN } from '../models/AcreditacionProfile';



// Assets


const StyledPage = styled(StyledPageContent)`
  display: grid;
  height: 100%;
`

const LogosLogin= styled.div`
  display:grid;
  grid-template-columns: auto auto auto;
  padding:50px 0px;
  max-width: 500px;
  > div{
    align-self: center;
    img{
      max-width: 70px;
    }
  }
`;

const LinkInstruciones=styled.div`
  padding:10px 40px 10px;
  text-align:center;
  a{
    color:#000;
    text-decoration:underline;
    &:hover{
      text-decoration:none;
    }
  }
`;

const LineaHorizontal = styled.div`
 height: 2px;
 background-color:var(--color-azul);
 max-width:320px;
 width:100%;
 margin:10px auto;
`;

const LoginScreen = styled.main`
  form{
    margin-bottom: 0px;
  }
  button{
    text-transform:uppercase;
    height: 55px;
  }
`;

export default  () => {
    const history = useHistory();
    const [ LoginInForm, { loading }] = useMutation(LOGIN_IN);

    const { register, handleSubmit, watch, errors:errors_fomr } = useForm({
        defaultValues:(process.env.NODE_ENV==='development')?{
            email:'datarandomtestinfo@mailinator.com',
            password:'123456',      
        }:{}
    });

    const recaptchaRef = React.useRef<any>();


    const [submitError,setSubmitError] = useState<null|string>(null);
    const onSubmit = async (data:any) => {
        console.log('on Send data:',data);
        setSubmitError(null);
        
        try{
            let tokenCaptcha=null;
            if(process.env.REACT_APP_RECAPTCHA_ENABLED==='true'){
                tokenCaptcha = await recaptchaRef.current.executeAsync();
                recaptchaRef.current.reset(); 
            }

            let response=await LoginInForm({ 
                variables:data,
                context:{
                    clientName: 'LOGIN',
                    headers:{
                        'x-recapchatoken':tokenCaptcha
                    }
                }  
            });
            if(response.errors)
                throw new trowError(response.errors);


            console.log('lOGIN:',response.data.loginInProfile);
            let { profile, token }=response.data.loginInProfile;
          
            AcreditacionProfile.setToken(token);
            AcreditacionProfile.setProfile(profile);

            location.href='/';
        }catch(e){
            console.error(e);
            setSubmitError(e);
        }
    }

    return (
        <StyledPage>
            <LoginScreen className="login-wrapper">
                <div className="reg-logo" >
                    <img className="img-fluid" src="https://atleticodesanluis.mx/img/home/registro-logo.png" />
                </div>
                <AuthLayoutWrapper>

                    <div></div>
                    <div className="title">ACCESO PORTAL DE ABONADOS</div>
                    <br />
                    <br />
                    <br />
                    
                    <form onSubmit={handleSubmit(onSubmit)}>
                        
                        {submitError?<div className="error-message"><FormErrors errors={submitError} /></div>:null}
                        <input type="text" name="email" placeholder="Correo" ref={register} required />
                        <input type="password" name="password" placeholder="Contraseña" ref={register}  required />
                        <Button disabled={loading} className="important red-btn">INGRESAR</Button>
                      
                        <br/><br/>
                        <p><NavLink to='/reestablecer-contrasena'>¿Olvidaste tu contraseña?</NavLink></p>
                    </form>
                    <LogosLogin>
                    </LogosLogin>

                    <LineaHorizontal />
                    <p>
                    ¿No tienes cuenta?<br/>
                    Crea y activa tu cuenta
                    </p>
                    <br/>
                    <p>
                        <Button type="button" className="blue-btn" onClick={() => history.push('registro-atleti-id')}>CREAR CUENTA</Button>
                    </p>
                    
                   
                    <div className='aviso-priv'>
                        <a href="https://atleticodesanluis.mx/contenidos/aviso-de-privacidad" target="_blank">Aviso de privacidad</a> 
                    </div>
                    <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''} size="invisible" ref={recaptchaRef} />

                </AuthLayoutWrapper>
            </LoginScreen>
        </StyledPage>
    )
}